import { render, staticRenderFns } from "./SuggestedRecipeNews.vue?vue&type=template&id=25b974a2&scoped=true"
import script from "./SuggestedRecipeNews.vue?vue&type=script&lang=js"
export * from "./SuggestedRecipeNews.vue?vue&type=script&lang=js"
import style0 from "./SuggestedRecipeNews.vue?vue&type=style&index=0&id=25b974a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b974a2",
  null
  
)

export default component.exports